import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter, Mutation } from 'vuex-class';
import {
  CHECK_CREDENTIALS,
  LOGIN_PENDING,
  SET_LOGIN_PENDING,
  SET_SYSTEM_ERRORS,
  SYSTEM_ERRORS,
} from '@/types/system.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { SystemLogin } from '@/models/system/SystemLogin';
import { Inject } from 'vue-property-decorator';

@Component({})
export default class SystemInfoLoginComponent extends Vue {

  @Inject() public $validator: any;

  @Action(CHECK_CREDENTIALS, StoreNamespace.SYSTEM) public checkCredentials;

  @Mutation(SET_SYSTEM_ERRORS, StoreNamespace.SYSTEM) public setSystemErrors;
  @Mutation(SET_LOGIN_PENDING, StoreNamespace.SYSTEM) public setLoginPending;

  @Getter(SYSTEM_ERRORS, StoreNamespace.SYSTEM) public systemErrors!: string[];
  @Getter(LOGIN_PENDING, StoreNamespace.SYSTEM) public loginPending!: boolean;

  private loginAuth: SystemLogin = {} as SystemLogin;

  public mounted() {
    this.setLoginPending(false);
    this.setSystemErrors([]);
  }

  public loginSystemInfo() {
    this.$validator.validateAll('auth_form').then((result: any) => {
      this.checkCredentials(this.loginAuth);
    });
  }

}

